module.exports = __webpack_public_path__ + "static/media/1-Attal.67919abd.webp";